module.exports = __webpack_public_path__ + "static/immagine2-c748b016ccddef7ccc5e7c52f5727da6.png";